<template>
    <div id="afil-network">

        <img ref="af-network-img" id="af-network-img" />
        
        <div id="af-wrap" v-show="showTableList == false">
            <div id="af"></div>
        </div>

        <div id="afil-legend">
            <ul>
                <li ref="edge.UPR">
                    <div class="legend__line-through" v-if="!legend.edge.UPR"></div>
                    <div class="afil-legend-edge afil-legend-edge__upr">
                        <div class="afil-legend-edge__text"></div>
                    </div>
                    <div>Руководитель, Упр. компания</div>
                </li>
                <li ref="edge.UPR_HISTORY">
                    <div class="legend__line-through" v-if="!legend.edge.UPR_HISTORY"></div>
                    <div class="afil-legend-edge afil-legend-edge__lupr">
                        <div class="afil-legend-edge__text"></div>
                    </div>
                    <div>Бывший руководитель</div>
                </li>
                <li ref="edge.UCHR">
                    <div class="legend__line-through" v-if="!legend.edge.UCHR"></div>
                    <div class="afil-legend-edge afil-legend-edge__uchr">
                        <div class="afil-legend-edge__text">100%</div>
                    </div>
                    <div>Учредитель</div>
                </li>
                <li ref="edge.UCHR_HISTORY">
                    <div class="legend__line-through" v-if="!legend.edge.UCHR_HISTORY"></div>
                    <div class="afil-legend-edge afil-legend-edge__luchr">
                        <div class="afil-legend-edge__text">Учр.</div>
                    </div>
                    <div>Бывший учредитель</div>
                </li>
                <li ref="edge.REGISTRY_HOLDER">
                    <div class="legend__line-through" v-if="!legend.edge.REGISTRY_HOLDER"></div>
                    <div class="afil-legend-edge afil-legend-edge__reestr">
                        <div class="afil-legend-edge__text">Реестродерж.</div>
                    </div>
                    <div>Реестродержатель</div>
                </li>
                <li ref="edge.PREDSH">
                    <div class="legend__line-through" v-if="!legend.edge.PREDSH"></div>
                    <div class="afil-legend-edge afil-legend-edge__predsh">
                        <div class="afil-legend-edge__text">Предш</div>
                    </div>
                    <div>Предшественник</div>
                </li>
                <li ref="edge.PREEM">
                    <div class="legend__line-through" v-if="!legend.edge.PREEM"></div>
                    <div class="afil-legend-edge afil-legend-edge__preem">
                        <div class="afil-legend-edge__text">Преем.</div>
                    </div>
                    <div>Преемник</div>
                </li>
                <li ref="edge.RODSTV">
                    <div class="legend__line-through" v-if="!legend.edge.RODSTV"></div>
                    <div class="afil-legend-edge afil-legend-edge__rodstv">
                        <div class="afil-legend-edge__text">Родств.</div>
                    </div>
                    <div>Родственник</div>
                </li>
                <li ref="edge.STAFF">
                    <div class="legend__line-through" v-if="!legend.edge.STAFF"></div>
                    <div class="afil-legend-edge afil-legend-edge__staff">
                        <div class="afil-legend-edge__text">Сотруд.</div>
                    </div>
                    <div>Сотрудник</div>
                </li>
            </ul>
            <ul>
                <li ref="node.ULRos">
                    <div class="legend__line-through" v-if="!legend.node.ULRos"></div>
                    <i class="fa fa-building"></i>
                    Юридическое лицо
                </li>
                <li ref="node.ULIn">
                    <div class="legend__line-through" v-if="!legend.node.ULIn"></div>
                    <i class="fa fa-globe"></i>
                    Иностранное юридическое лицо
                </li>
                <li ref="node.FL">
                    <div class="legend__line-through" v-if="!legend.node.FL"></div>
                    <i class="fa fa-male"></i>
                    Физическое лицо
                </li>
                <li ref="node.IP">
                    <div class="legend__line-through" v-if="!legend.node.IP"></div>
                    <i class="fa fa-user"></i>
                    Индивидуальный предприниматель
                </li>
                <li ref="node.PIF">
                    <div class="legend__line-through" v-if="!legend.node.PIF"></div>
                    <i class="fa fa-university"></i>
                    Субъект РФ, ПИФ
                </li>
                <li ref="status.green">
                    <div class="legend__line-through" v-if="!legend.status.green"></div>
                    <div class="status-color-block status-color-block__green"></div>
                    Действущее
                </li>
                <li ref="status.orange">
                    <div class="legend__line-through" v-if="!legend.status.orange"></div>
                    <div class="status-color-block status-color-block__orange"></div>
                    В стадии ликвидации
                </li>
                <li ref="status.red">
                    <div class="legend__line-through" v-if="!legend.status.red"></div>
                    <div class="status-color-block status-color-block__red"></div>
                    Ликвидированое
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { htmlStringToPrint } from '@/helpers.ts'
import { base64StringToBlob } from 'blob-util'
import modal from '@/components/ui/modal.vue'
import shestirenka from '@/components/ui/shestirenkaLoader.vue'

export default {
    props: ['ogrn', 'group', 'flAfilData'],
    components: {
        modal,
        shestirenka
    },
    data(){
        return {
            loading: true,
            modalList: [],
            showTableList: false,
            resetActive: false,
            // showFullScreen: false,
            showLegend: false,
            nodesToHide: [],
            AF: {
                nodes: [],
                edges: []
            },
            print: {
                title: 'Аффилированность',
                filename: `Affilation-${this.$props.ogrn}`
            },
            legend: {
                node: {
                    ULRos: true, // Юридическое лицо РФ
                    ULIn: true, // Иностранное юридическое лицо
                    FL: true, // Физическое лицо
                    IP: true, // Индивидуальный предприниматель
                    PIF: true // субьект РФ
                },
                status: {
                    green: true, // статус действующее
                    orange: true, // стстус в стадии ликвидации
                    red: true // статус ликвидированно
                },
                edge: {
                    UPR: true, // Руководитель
                    UPR_HISTORY: true, // бывший рук
                    UCHR: true, // Учредитель
                    UCHR_HISTORY: true,
                    REGISTRY_HOLDER: true,
                    PREDSH: true,
                    PREEM: true,
                    RODSTV: true,
                    STAFF: true
                }
            }
        }
    },
    computed: {
        userGroups(){
            return this.$store.state.user.groups.filter(e => e.rules.monitoring_fl)
        }
    },
    mounted(){
        var SELF = this;

        var affilation = {}

        var AF = {
            stabilizing: true,
            handle: null,
            network: null,
            data: null,
            nodes: null,
            edges: null,
            options: {
                interaction: {
                    hover: true
                },
                physics: {
                    enabled: true,
                    barnesHut: {
                        gravitationalConstant: -8308,
                        centralGravity: .5
                    },
                    maxVelocity: 10,
                    minVelocity: .5,
                    timestep: 1,
                },
                nodes: {  shape: 'dot', size: 20, borderWidth: 0, font: { face: 'Monospace', size: 10, color: '#000000', strokeWidth: 3, strokeColor : '#ffffff'  } },
                edges: {  width: 1, color: '#cbc7cd', font: { face: 'Monospace', size: 10, color: '#000', strokeWidth: 3, strokeColor : '#ffffff' } },
                groups: {
                    ULRos: 		{ shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf1ad', color: '#999' } }, // Юридическое лицо РФ,
                    ULIn: 		{ shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf0ac', color: '#999' } }, // Иностранное юридическое лицо,
                    FL:         { shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf183', color: '#999' } }, // Физическое лицо
                    IP: 		{ shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf007', color: '#999' } }, // Индивидуальный предприниматель
                    RFSubMO: 	{ shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf19c', color: '#999' } }, // субьект РФ,
                    UL: 		{ shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf1ad', color: '#999' } }, // Управляющая компания
                    PIF: 		{ shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf19c', color: '#999' } }, // Паевый инвестиционный фонд
                    UprCompPIF: { shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf19c', color: '#999' } }, // Управляющая компания ПИФ-а
                    WTF: 		{ shape: 'icon', icon: { face: 'FontAwesome', size: 30, code: '\uf21b', color: '#999' } }, // Неизвестный тип лица
                }
            },
            hide: {
                links: [],
                nodes: [],
            },
            show_edges: [],
            show_id: [],
            show_limit: 1000,
            mainCompany: this.$props.ogrn,
            getNode: function(id) {
                var result = false;

                for (var i in AF.data.nodes._data) {
                    var node = AF.data.nodes._data[i];
                    if (node.id == id) {
                        result = node;
                        break;
                    }
                }

                return result;
            },
            getEdge: function(from, to) {
                var result = false;
                for (var i in AF.data.edges._data) {
                    var edge = AF.data.edges._data[i];
                    if (edge.from == from && edge.to == to) {
                        result = edge;
                        break;
                    }
                    if (edge.to == from && edge.from == to) {
                        result = edge;
                        break;
                    }
                }
                return result;
            }
        }

        AF.init = function() {
            AF.handle = document.getElementById('af')
            AF.nodes = new vis.DataSet()
            AF.edges = new vis.DataSet()
            AF.data = { nodes: AF.nodes, edges: AF.edges }

            AF.network = new vis.Network(AF.handle, AF.data, AF.options)
            AF.network.on("beforeDrawing", function(ctx) {
                ctx.save()
                ctx.setTransform(1, 0, 0, 1, 0, 0)
                ctx.fillStyle = '#ffffff'
                ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)
                ctx.restore()
            })
        }

        AF.renderCompany = (company, main_level) => {
            var id = ''
            var color = ''
            var title = ''
            var group = ''
            var expanded = false
            var loading = false
            var companyNode = false
            var statusText = ''
            var level = null

            AF.show_edges = []

            for (let i in company.links) {
                let item = company.links[i];
                if (AF.show_edges.length < AF.show_limit && item.rel_id && item.id) {
                    AF.show_edges.push(item);
                    if (AF.show_id.indexOf(item.rel_id) == -1) AF.show_id.push(item.rel_id);
                    if (AF.show_id.indexOf(item.id) == -1) AF.show_id.push(item.id);
                } else {
                    AF.hide.links.push(item);
                }
            }

            for (let i in company.nodes) {
                let item = company.nodes[i];

                // Проверяем, нужно ли показывать ноду, если нет, переходим к следующей
                if (AF.show_id.indexOf(item.id) == -1) {
                    AF.hide.nodes.push(item);
                    continue;
                }

                id = item.id;
                title = item.title_short ? item.title_short : item.title_full;
                group = item.rec_type;
                expanded = id == AF.mainCompany;
                loading = false;
                level = id == AF.mainCompany ? 0 : main_level + 1
                switch (item.status) {
                    case 0:
                        color = '#e85445';
                        statusText = "red"
                        break;
                    case 1:
                        color = '#2ecc71';
                        statusText = "green"
                        break;
                    case 2:
                        color = '#e7843c';
                        statusText = "orange"
                        break;
                    default:
                        color = '#999';
                        statusText = false
                        break;
                }

                // проверяем, нет ли уже такой компании
                companyNode = AF.getNode(id);
                if (false == !!companyNode) {
                    AF.nodes.add({
                        data: {
                            title,
                            level,
                            inn: item.inn,
                            ogrn: item.ogrn
                        },
                        statusText,
                        mass: 0.5,
                        id,
                        label: title,
                        group,
                        expanded,
                        loading,
                        level,
                        icon: { color }
                    })
                    this.AF.nodes.push({ mass: 0.5, id, label:title, group, expanded, loading, icon: { color }})
                } else {
                    AF.nodes.update([ { id, label:title, group, loading, icon: { color } } ])
                }
            }

            for (let i in AF.show_edges) {
                let item = AF.show_edges[i];
                var from, to;

                // выбор направления стрелки
                if (item.rel_direction == "back") {
                    from = item.rel_id;
                    to = item.id;
                } else {
                    from = item.id;
                    to = item.rel_id;
                }
                title = item.rel_type == 'UCHR' && item.dolya_procent ? item.dolya_procent + '%' : (item.rel_type_title ? (item.relative_type ? item.relative_type : item.rel_type_title) : '');
                // Если руководитель, то ничего не пишем:
                title = item.rel_type == 'UPR' || item.rel_type == 'UPR_HISTORY' ? '' : title;

                switch(item.rel_type){
                    case 'UPR': color = '#2980b9'
                    break;
                    case 'UPR_HISTORY':  color = '#2980b9'; break;
                    default: color = to == AF.mainCompany ? '#777' : '#cbc7cd';
                }

                var dashes = item.rel_type == 'PREEM' || item.rel_type == "PREDSH" || item.rel_type == "UPR_HISTORY" || item.rel_type == "UCHR_HISTORY";

                // Существование текущей ветки
                var currentEdge = AF.getEdge(from, to) || AF.getEdge(to, from);

                // Если нет, то добавляем, иначе обновляем
                if (false == !!currentEdge) {
                    AF.edges.add({
                        id: `${from}_${to}`,
                        arrows: { to: { scaleFactor:0.5 } },
                        label: title,
                        rec_type: item.rec_type,
                        rel_type: item.rel_type,
                        from,
                        to,
                        color,
                        dashes
                    })
                    this.AF.edges.push({ id:from+'_'+to,  from:from, to:to, arrows:{to:{scaleFactor:0.5}}, label:title, color: color, dashes: dashes })
                } else {
                    color = currentEdge.color == '#2980b9' ? '#2980b9' : color;								// выставляем приоритет цвета (если цвет руководителя, то сохраняем, иначе текущий)
                    title = currentEdge.label != '' && (item.rel_type == 'UPR' || item.rel_type == 'UPR_HISTORY') ? currentEdge.label : title;	// Если подпись есть и она не "руководитель", то сохраняем старую. Иначе текущая.

                    AF.edges.update({id:currentEdge.id, from:currentEdge.from, to:currentEdge.to, arrows:{to:{scaleFactor:0.5}}, label:title, color: color, dashes: dashes });
                }
            }


            setTimeout(() => {
                AF.network.fit({
                    // animation: false
                })
            }, 2000)

            setTimeout(() => {
                this.$refs['af-network-img'].setAttribute("src", document.querySelector("#af .vis-network canvas").toDataURL("image/png", 1))
            }, 1500)
        }
        
        AF.init()

        AF.renderCompany(this.$props['flAfilData'], 0)
    }
}
</script>

<style scoped lang="scss">
@import "styles/global-variables.sass";

$af-height: 500px;
$af-width: 960px;

#af-network-img {
    width: $af-width;
    height: $af-height;
}

#af {
    position: unset;
    top: auto;
    left: auto;
    z-index: 1;
    width: $af-width;
    height: $af-height;
    background: none;
}

#afil-network {
    height: $af-height;
    width: $af-width;
    position: relative;
    .full-screen-menu {
        &__item {
            @extend .blue-red-hover-text;
            font-weight: 400;
            display: block;
            text-align: right;
            font-size: 18px;
            margin: 2px 0;
        }
    }
}

@media screen and (max-width: 960px) {
    .affiliantion-modal-list__level {
        display: none;
    }
    .affiliantion-modal-list {
        margin-left: 5px !important;
    }
}

ul.affiliantion-modal-list > li.affiliantion-modal-list__level {
    position: absolute;
    right: 10px;
    top: 0;
    font-weight: 700;
    color: #aaa;
}

ul.affiliantion-modal-list {
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-right: 5px;
    padding: 5px 10px;
    position: relative;
}

ul.affiliantion-modal-list:nth-child(2n) {
    background: #eee;
}

ul.affiliantion-modal-list > li.affiliantion-modal-list__header {
    color: #1e8bc3;
    font-weight: 600;
    font-family: Roboto Slab, Arial, Helvetica, sans-serif;
}
ul.affiliantion-modal-list > li > a {
    border: 0;
}
ul.affiliantion-modal-list > li {
    margin: 5px 0;
}


.full-screen-menu {
    position: absolute;
    right: 5px;
    z-index: 1000000001;
    font-size: 20px;
}

#af-wrap {
    width: 100%;
    height: $af-height;
    max-height: 100%;
    min-height: 100%;
    position: relative;
    margin: 0 auto;
    background-color: #fafafa;
}
</style>

<style>
    #afil-network-demo-msg {
        text-align: center;
        font-size: 17px;
        color: #777;
    }

    #afil-network {
        position: relative;
    }

    #affiliation-tile-node-info-wrap {
        color: black;
        display: none;
        width: 350px;
        height: auto;
        background-color: #f5f5f5;
        border: 1px solid #c5c5c5;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 5px;
        padding: 10px;
        box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.5);
    }

    #affiliation-tile-node-info-wrap .lnr-cross {
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
    }

    #affiliation-tile-node-info-close {
        max-width: 5%;
        font-size: 25px;
        line-height: 0;
        float: right;
    }

    #affiliation-tile-node-header { 
        max-width: 95%;
    }

    #affiliation-tile__node-hover-menu i {
        top: 0;
        left: 0;
        z-index: 1234;
        position: absolute;
        display: none;
        color: #999;
        pointer-events: all;
        cursor: pointer;
        font-size: inherit;
        background-color: #fff;
        border-radius: 100%;
        display: inline-block;
        font-size: 12px;
        width: calc(12px * 2);
        height: calc(12px * 2);
        line-height: calc(12px * 2);
        text-align: center;
        border: 1px solid #999;
    }

    #affiliation-tile__node-hover-menu i:hover {
        color: red;
        border: 1px solid red;
    }

    #afil-network > div.uk-panel.uk-panel-box {
        overflow: hidden;
    }

    #affiliation-tile-node-header {
        max-width: 95%;
        font-weight: bold;
        font-size: 14px;
        color: #1e8bc3;
        font-family: Roboto Slab, Arial, Helvetica, sans-serif;
    }

    #affiliation-tile-node-info {
        font-size: 12px;
    }

    #affiliation-tile-node-info > div:first-child {
        margin-top: 10px;
        font-style: italic;
    }

    #affiliation-tile-node-info > div {
        margin: 5px 0;
    }
</style>